import MyEvgmRoute from './MyEvgmRoute'
import CreateEVGMRoute from './CreateEVGMRoute'

const routes = [
    new MyEvgmRoute(),
    new CreateEVGMRoute()
]

export default routes